export const getCodeFolder = (agentId?: string, interchageName?: string): string => {
  return `agents/${agentId || '-'}/${interchageName || 'interchange'}`;
};
